module.exports = __webpack_public_path__ + "img/Trace.22cb0e24.svg";